
import { z } from "zod";

export const ComplexityTypeValues = ["LOW", "MEDIUM", "HIGH", "PRE_COMPLEXITY_INPUT", "LOW_8", "MEDIUM_11", "HIGH_16"] as const;
export const ComplexityTypeSchema = /* @__PURE__ */ z.enum(ComplexityTypeValues);
export const ComplexityType: (typeof ComplexityTypeSchema)["enum"] = { "LOW": "LOW", "MEDIUM": "MEDIUM", "HIGH": "HIGH", "PRE_COMPLEXITY_INPUT": "PRE_COMPLEXITY_INPUT", "LOW_8": "LOW_8", "MEDIUM_11": "MEDIUM_11", "HIGH_16": "HIGH_16" };
export type ComplexityType = (typeof ComplexityTypeValues)[number];
